import * as Rx from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import { ToastController } from 'ionic-angular';
import { APP_WEBSOCKET_URL } from '../config/constants';

@Injectable()
export class WsService {
	constructor(public toastCtrl: ToastController) {
    }
    // 定义websocket服务地址
    wsUrl: string = APP_WEBSOCKET_URL;
    // 用于保存当前subject对象
    subject: Rx.Subject<any>;
    // 用于保存当前subject对象publish后返回的可观察对象
    publish: Rx.ConnectableObservable<any>;
    num: number = 0;
    private create(): Rx.Subject<any>{
        // 创建websocket对象
        let ws = new WebSocket(this.wsUrl);
        // 创建Observable对象
        let observable = Rx.Observable.create(
            (obs: Rx.Observer<any>) => {
                // 当websocket获得推送内容的时候，调用next方法，并传入推送内容
                ws.onmessage =  obs.next.bind(obs);
                // 当websocket出错的时候，调用error方法，并传入失败信息
                ws.onerror = obs.error.bind(obs);
                // 当websocket关闭的时候，调用complete方法
                ws.onclose = obs.complete.bind(obs);
                return ws.close.bind(ws);
            }
        );
        observable.subscribe({
		  next: x => this.onMessage(x),
		  error: err => console.error('something wrong occurred: ' + err),
		  complete: () => console.log('done'),
		});
        // 创建observer对象，用于向websocket发送信息
        let observer = {
            next: (value) => {
            	console.log(value);
                if (ws.readyState == WebSocket.OPEN) {
                    ws.send(value.toString());
                }
            },
        };
        // 使用Rx.Subject.create创建Subject对象
        return Rx.Subject.create(observer, observable);
    }
    
   /* constructor(public toastCtrl: ToastController) {
    	
 	}*/
    // 获取subject对象接口
    getSubject() {
      if (!this.subject) {
        this.subject = this.create();
      }
      return this.subject;
    }
    // 获取publish对象接口
    getPublish() {
        if (!this.publish) {
            this.publish = this.subject.publish();
        }
        return this.publish;
    }
    
    onMessage(event){
    	//console.log(event.data);
    	this.alertMsg(event.data,'middle',1000);
    }
    onOpen(event){
    	console.log(event.data);
    }
    onError(event){
    	console.log(event.data);
    }
    
    /** 弹出框
    * msg  :弹出框显示信息
    * pst  :显示位置  top middle  bottom 
    * num  : 显示的时间长度  1000 = 1秒
    */
   alertMsg(msg:string,pst: string,num:number){
		let toast = this.toastCtrl.create({
		    message: msg,
		    duration: num,
		    showCloseButton: true,
      		closeButtonText: 'Ok',
		    position: pst
	    });
	    toast.present();
   }
}


// WEBPACK FOOTER //
// ./src/providers/service/websocket.ts